export const AUTH_TOKEN_KEY = 'neopak_auth_token';

export const getAuthToken = () => {
	if (typeof window === 'undefined') return null;
	return window.localStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token: string | null) => {
	if (typeof window === 'undefined') return;
	if (token) {
		window.localStorage.setItem(AUTH_TOKEN_KEY, token);
	} else {
		window.localStorage.removeItem(AUTH_TOKEN_KEY);
	}

	window.dispatchEvent(new CustomEvent('neopak-auth', { detail: token }));
};

export const isPanelAuthContext = () => {
	if (typeof window === 'undefined') return false;
	const params = new URLSearchParams(window.location.search);
	return params.get('auth') === 'panel';
};
